import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ProductTile from './ProductTile';
import { Swiper as SwiperInstance, SwiperSlide } from 'swiper/react';
const ProductShopTheLookPanel = (props) => {
    const { looks, startingItem } = props;
    const { t } = useTranslation();
    const [currentItem, setCurrentItem] = useState(startingItem);
    const formattedCurrentNumber = (currentItem + 1).toString().padStart(2, '0');
    const formattedTotalNumber = looks.length.toString().padStart(2, '0');
    const fromModule = props.fromMainModule ? 'fromModule' : 'fromInfo';
    //* SECTION - RENDER --------------------------------------------------------------------
    return (React.createElement("div", { className: "shopthelookpanel" },
        React.createElement("div", { className: "" },
            looks.length > 1 && (React.createElement("div", { className: "shopthelook-upper" },
                React.createElement("div", { className: "shopthelookpanel-title font__title" },
                    React.createElement("span", null,
                        t('label.item'),
                        ":",
                        `${formattedCurrentNumber}/${formattedTotalNumber}`)),
                React.createElement("div", { className: "shopthelook__arrow-container" },
                    React.createElement("button", { className: "shopthelook__arrow shopthelook__arrow-left swiper-button-prev", disabled: currentItem <= 0, "aria-label": t('carousel.prevslidemessage') },
                        React.createElement("i", { className: "icon--10-left-chevron", "aria-hidden": true })),
                    React.createElement("button", { className: "shopthelook__arrow shopthelook__arrow-right swiper-button-next", disabled: currentItem >= looks.length - 1, "aria-label": t('carousel.nextslidemessage') },
                        React.createElement("i", { className: "icon--10-right-chevron", "aria-hidden": true }))))),
            React.createElement("div", { className: "shopthelookpanel-item" },
                React.createElement(SwiperInstance, { onSlideChange: (swiper) => {
                        setCurrentItem(swiper.activeIndex);
                    }, keyboard: true, navigation: {
                        nextEl: '.shopthelook__arrow-right',
                        prevEl: '.shopthelook__arrow-left',
                    }, mousewheel: {
                        forceToAxis: true,
                        thresholdDelta: 20,
                    }, virtualTranslate: true, touchAngle: 15, className: "swiper-container", initialSlide: startingItem, speed: 1000, slidesPerView: 1 }, looks === null || looks === void 0 ? void 0 : looks.map((currentLook) => (React.createElement(SwiperSlide, { key: currentLook.uuid },
                    React.createElement(ProductTile, { fullExpanded: true, inShopTheLookPanel: fromModule, product: currentLook, onSuccessAddToBag: props.onClose })))))))));
};
export default ProductShopTheLookPanel;
